import { IWithHistory } from "@common/util/withHistory";
import { IHasXAndY, Point, Size } from "../Renderer/types";
import { Page, Zone, ZoningTaxonomy } from "../types";
import { ChangeCurrentLabelAction } from "./reducers/changeCurrentLabel";
import { ChangeLabelColorAction } from "./reducers/changeLabelColor";
import { ChangeZoomLevelAction } from "./reducers/changeZoomLevel";
import { KeyPressedAction } from "./reducers/keyPressed";
import { MouseDownAction } from "./reducers/mouseDown";
import { MouseLeaveAction } from "./reducers/mouseLeave";
import { MouseMoveAction } from "./reducers/mouseMove";
import { MouseUpAction } from "./reducers/mouseUp";
import { ResetZonesAction } from "./reducers/resetZones";
import { SavePageAction } from "./reducers/savePage";
import { SelectPageAction } from "./reducers/selectPage";
import { SetEditingTableAction } from "./reducers/setEditingTable";
import { SetNoiseReductionLevelAction } from "./reducers/setNoiseReductionLevel";
import { SetTableCellsAction } from "./reducers/setTableCells";
import { StarLabelAction } from "./reducers/starLabel";

export interface ISelection {
  endx: number;
  endy: number;
  startx: number;
  starty: number;
}

export enum ResizeHandlerPosition {
  TOP,
  RIGHT,
  BOTTOM,
  LEFT,
}

export enum ZoomLevel {
  "1x" = 1,
  "1.5x" = 1.5,
  "2x" = 2,
  "2.5x" = 2.5,
  "3x" = 3,
}

export enum CurrentAction {
  CREATING_ZONE,
  HOVERING_NOTHING,
  HOVERING_ZONE,
  MOVING,
  RESIZING_BOTTOM,
  RESIZING_LEFT,
  RESIZING_RIGHT,
  RESIZING_TOP,
  SELECTING,
}

export enum PageSaveState {
  Clean,
  Dirty,
  Saving,
}

export type PageState = Page &
  Readonly<{
    activeZones: Array<number>;
    currentAction: CurrentAction;
    dimensions: Size;
    firstDragEvent: boolean;
    hoveredZone: number;
    image: HTMLImageElement | null;
    noiseReductionLevel: number;
    pageSaveState: PageSaveState;
    previousMouseLocation: Point | null;
    selection: ISelection | null;
    zoneHistory: IWithHistory<Array<Zone>>;
    showZoneLabels: boolean;
  }>;

export enum TaxonomyMode {
  Simple,
  Complex,
}

export interface TaxonomyState {
  mode: TaxonomyMode;
  orderedLabels: {
    starred?: Array<string>;
    image?: Array<string>;
    math?: Array<string>;
    table?: Array<string>;
    text?: Array<string>;
  };
  rawLabels: ZoningTaxonomy;
}

export type State = Readonly<{
  activePage: number;
  currentLabelGroup: keyof TaxonomyState["orderedLabels"] | "";
  currentLabel: string;
  pages: Array<PageState>;
  previousPage: number;
  taxonomy: TaxonomyState;
  editTable: number | null;
  zoom: ZoomLevel;
  tableZoom: ZoomLevel;
  pointerPosition?: IHasXAndY;
  showZoneLabels : boolean;
}>;

export type Action =
  | ChangeCurrentLabelAction
  | ChangeLabelColorAction
  | ChangeZoomLevelAction
  | KeyPressedAction
  | MouseDownAction
  | MouseLeaveAction
  | MouseMoveAction
  | MouseUpAction
  | ResetZonesAction
  | SavePageAction
  | SelectPageAction
  | SetEditingTableAction
  | SetNoiseReductionLevelAction
  | SetTableCellsAction
  | StarLabelAction;

export type Dispatch = (action: Action) => void;
